import { SocialNetwork } from './social';

// Publishing status for posts
export type PublishStatus = 'draft' | 'scheduled' | 'publishing' | 'published' | 'failed';

// Social media account connection
export interface SocialAccount {
  id: string;
  workspaceId: string;
  network: SocialNetwork;
  accountName: string;
  accountId?: string;
  connectedAt: string;
}

// Scheduling fields added to posts
export interface ScheduledPostFields {
  scheduledFor?: string | null;
  publishedAt?: string | null;
  publishStatus: PublishStatus;
  publishError?: string | null;
  externalPostId?: string | null;
}

// Request to schedule a post
export interface SchedulePostRequest {
  scheduledFor: string; // ISO date string
  socialAccountId: string;
}

// Request to publish a post immediately
export interface PublishPostRequest {
  socialAccountId: string;
}

// Calendar event representation
export interface CalendarEvent {
  id: string;
  postId: string;
  network: SocialNetwork;
  content: string;
  imageUrl: string | null;
  scheduledFor: string;
  publishStatus: PublishStatus;
  publishedAt?: string | null;
}

// Request to connect a social account
export interface ConnectSocialAccountRequest {
  network: SocialNetwork;
  accountName: string;
  accountId?: string;
  accessToken?: string;
  refreshToken?: string;
  tokenExpiresAt?: string;
}
